// Ability tick + input orchestration.

import type { World } from './world';
import type { InputFrame } from './input';
import { listAbilities } from './abilities';
import { G } from './state';
import { K_SP, K_UP, K_DN, K_LT, K_RT } from './constants';
import { keyHeld } from './input';
import {
  setPsiCircuitRelease,
  chargePsiCircuit,
  recoverPsiCircuit,
  firePsiCircuit,
} from './abilities/psi-circuit';
import { tryDashBlinkAbility } from './behaviors/dash-blink';

let prevSpHeld = false;
let releaseHooked = false;

export function resetAbilityRuntime(): void {
  prevSpHeld = false;
  releaseHooked = false;
}

/** Process PSI charge/release and demo abilities each movement tick. */
export function processAbilityMovement(
  world: World,
  input: InputFrame,
  releaseCircuitCallback?: () => void
): void {
  if (releaseCircuitCallback && !releaseHooked) {
    setPsiCircuitRelease(releaseCircuitCallback);
    releaseHooked = true;
  }

  const spHeld = keyHeld[K_SP] !== 0;
  const spEdgePress = spHeld && !prevSpHeld;
  const spReleased = prevSpHeld && !spHeld;
  prevSpHeld = spHeld;

  if (G.magic_circuit < 0) {
    recoverPsiCircuit();
  }
  if (spHeld) {
    chargePsiCircuit();
  } else if (spReleased && G.magic_circuit > 0) {
    firePsiCircuit();
  }

  const moving = keyHeld[K_UP] || keyHeld[K_DN] || keyHeld[K_LT] || keyHeld[K_RT];
  if (spEdgePress && moving) {
    tryDashBlinkAbility(world);
  }
}

export function tickAbilities(world: World, dt: number): void {
  for (const ability of listAbilities()) {
    if (ability.isUnlocked && !ability.isUnlocked(world)) continue;
    ability.onTick?.(world, dt);
  }
}
